import React, { useState } from 'react';
import toastr from 'toastr';
import Modal from '../Modal/Modal';
import styles from './ModalCopy.module.scss';
import Button from '../Button/Button';
import { COPIED_SUCCESS, COPIED_FAIL } from '../../../constans/texts/texts';

function ModalCopy({ copiedString, show, displayToggle }) {
  const [disableCopiedBtn, setDisableCopiedBtn] = useState(false);

  const shareHandler = () => {
    setDisableCopiedBtn(true);
    navigator.clipboard.writeText(copiedString)
      .then(() => {
        toastr.success(COPIED_SUCCESS, '', { timeOut: 500 });
        setDisableCopiedBtn(false);
      })
      .catch(() => {
        toastr.error(COPIED_FAIL);
        setDisableCopiedBtn(false);
      });
  };
  return (
    <Modal
      modalClasses={styles.shareModal}
      show={show}
      displayToggle={displayToggle}
    >
      <div className={styles.shareModalContent}>
        <p className={`${styles.linkText} t-500`}>
          {copiedString}
        </p>
        <Button
          disabled={disableCopiedBtn}
          onClick={shareHandler}
          classes={`${styles.copyBtn} btn flex btn_mld btn_common t-600 btn-uppercased`}
        >
          <span className="btn__text">
            Copy
          </span>
        </Button>
      </div>
    </Modal>
  );
}

ModalCopy.defaultProps = {
  copiedString: '',
};

export default ModalCopy;
